/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovKoRarIcon16Light } from './GovKoRarIcon16Light';
import { GovKoRarIcon16Regular } from './GovKoRarIcon16Regular';
import { GovKoRarIcon16Solid } from './GovKoRarIcon16Solid';
import { GovKoRarIcon20Light } from './GovKoRarIcon20Light';
import { GovKoRarIcon20Regular } from './GovKoRarIcon20Regular';
import { GovKoRarIcon20Solid } from './GovKoRarIcon20Solid';
import { GovKoRarIcon24Regular } from './GovKoRarIcon24Regular';
import { GovKoRarIcon24Solid } from './GovKoRarIcon24Solid';
import { GovKoRarIcon32Regular } from './GovKoRarIcon32Regular';
import { GovKoRarIcon64Regular } from './GovKoRarIcon64Regular';
var sizes = {
    16: {
        light: GovKoRarIcon16Light,
        regular: GovKoRarIcon16Regular,
        solid: GovKoRarIcon16Solid,
    },
    20: {
        light: GovKoRarIcon20Light,
        regular: GovKoRarIcon20Regular,
        solid: GovKoRarIcon20Solid,
    },
    24: {
        regular: GovKoRarIcon24Regular,
        solid: GovKoRarIcon24Solid,
    },
    32: {
        regular: GovKoRarIcon32Regular,
    },
    64: {
        regular: GovKoRarIcon64Regular,
    },
};
export var GovKoRarIcon = forwardRef('GovKoRarIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
